<template>
  <layout-login>
    <h2 class="invite-title">
      {{ $t('message["1240"]') }}
    </h2>
    <div>
      <cube-form
        :model="model"
        :options="options"
        @validate="validateHandler"
        @submit.prevent="submitHandler"
      >
        <cube-form-item :field="fields[0]" />
        <div class="cube-form-item-box">
          <cube-form-item :field="fields[1]" />
          <div class="find-pwd-box">
            <cube-form-item :field="fields[2]" />
          </div>
        </div>
        <cube-form-group>
          <cube-button
            type="submit"
            :primary="true"
            :disabled="sDisabled"
          >
            {{ $t('message["597"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
    </div>
  </layout-login>
</template>

<script type="text/ecmascript-6">
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
import { mapActions } from 'vuex'
import { accountFields, options } from '@/components/mobile/invite/common'
export default {
  components: {
    LayoutLogin
  },
  data () {
    return {
      isValid: false,
      sDisabled: true,
      model: {
        username: '',
        password: ''
      },
      options,
      fields: accountFields
    }
  },
  computed: {
    inviteLogin () {
      const { mobile, invitecode, ensecret } = this.$route.query
      return { mobile, invitecode, ensecret }
    }
  },
  methods: {
    ...mapActions('team/invite', ['fetchSupplyUsersInfoInvite']),
    async submitHandler (e) {
      const _this = this
      if (this.isValid) {
        let params = Object.assign(this.model, this.inviteLogin)
        const chain = await this.fetchSupplyUsersInfoInvite(params)
        chain.onFail((err, all) => {
          console.log(err)
          const { payload } = all
          _this.$selefToast({ type: 'error', text: payload[0]['message'] })
        })
          .fetch()
      }
    },
    validateHandler (result) {
      const { valid } = result
      this.isValid = valid
      this.sDisabled = !this.isValid
    }
  }
}
</script>

<style scoped lang="scss">
.invite-title {
  width: 279px;
  margin: 30px auto;
}
.invite-title, .invite-company {
  color: #333;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  .invite-company {
    margin: 0 5px;
  }
}
</style>
